/**
 * * Модель запроса на перемещение группы
 */
export default class MoveGroupRequest  {
	/**
	 * * Номер группы
	 */
	GroupId!: number;
	/**
	 * * Номер родительской группы
	 */
	ParentGroupId?: number;
	/**
	 * * Номер родителя рабочей области
	 */
	ParentNamespaceId?: string;
	constructor(obj?: Partial<MoveGroupRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
